import React from "react";
import {Link, useNavigate, useParams} from "react-router-dom";
import {
    addDetailBlogsComments,
    Blog,
    CommentData,
    getDetailBlogs,
    getDetailBlogsComments
} from "../../Actions/BlogActions";
import {useParameterizedQuery} from "react-fetching-library";
import {AnimateBox} from "../../Components/GenericComponents/AnimateBox";
import {BlogSkeleton} from "../News/BlogSkeleton";
import {NotFound} from "../NotFound/NotFound";
import {Button, Col, Image, Row} from "react-bootstrap";
import moment from "moment/moment";
import Moment from "react-moment";
import {Magic, MagicSDKExtensionsOption, MagicUserMetadata} from "magic-sdk";
import { InstanceWithExtensions, SDKBase } from "@magic-sdk/provider";
import CryptoJS from 'crypto-js';

const validateEmail = (email: string): boolean => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
};

const getUIAvatar = (email: string) => {
    const md5Email = CryptoJS.MD5(email.toLowerCase().trim()).toString();
    return `https://www.gravatar.com/avatar/${md5Email}?d=identicon`;

};


export const BlogDetailPage: React.FunctionComponent = (_props) => {
    const {id} = useParams();

    const getDetailBlogsAction = useParameterizedQuery(getDetailBlogs);
    const getDetailBlogsCommentsAction = useParameterizedQuery(getDetailBlogsComments);
    const addDetailBlogsCommentsAction = useParameterizedQuery(addDetailBlogsComments);

    const [isLoading, setIsLoading] = React.useState(false);

    const [blog, setBlog] = React.useState<Blog|undefined>();
    const [comments, setComments] = React.useState<CommentData[]>([]);
    const [isLoadingComment, setIsLoadingComment] = React.useState(true);

    const [commentSTR, setCommentSTR] = React.useState<string>('');
    const [email, setEmail] = React.useState<string>('');

    const [magic, setMagic] = React.useState<InstanceWithExtensions<SDKBase, MagicSDKExtensionsOption<string>>>();
    const [isValidEmail, setIsValidEmail] = React.useState<boolean>(true);

    const [userInfo, setUserInfo] = React.useState<MagicUserMetadata|null>(null);
    const [token, setToken] = React.useState<string>();

    const navigate= useNavigate();

    const scrollTo = React.useCallback((selectorId: string) => {
        setTimeout(() => {
            const element = document.getElementById(selectorId);
            if (element) {
                element.scrollIntoView({behavior: 'smooth'});
            }
        }, 50);
    }, []);

    React.useEffect(()=>{
        if ( id !== undefined ){
            if(!isLoading){
                setIsLoading(true);
                getDetailBlogsAction.query({id:id}).then( r => {
                    if( r.payload !== undefined ){
                        setBlog(r.payload);

                        if(r.payload.comments){
                            setComments(r.payload.comments);
                            setIsLoadingComment(true);
                        }else {
                            setComments([]);
                            setIsLoadingComment(false);
                        }
                    }
                })
            }

        }
    }, [getDetailBlogsAction, id, isLoading])

    React.useEffect(()=>{
        if ( id !== undefined ){
            if(!isLoadingComment){
                setIsLoadingComment(true);
                getDetailBlogsCommentsAction.query({id:id}).then( r => {
                    if( r.payload !== undefined ){
                        setComments(r.payload);
                    }
                })
            }
        }
    }, [getDetailBlogsCommentsAction, id, isLoadingComment])

    const slug = React.useMemo(()=>{
        if(blog !== undefined) {
            const slugData= blog.title.replace(/ /g, "-");
            return encodeURIComponent(slugData);
        }

    }, [blog])

    const sortedComment = React.useMemo(()=>{
        const sortedData : CommentData[] = [];

        if (comments === undefined || comments.length === 0){
            return sortedData;
        }

        return comments.sort((a, b) => {
            const momentA = moment(a.created)
            const momentB = moment(b.created)

            return momentA.isBefore(momentB) ? 1 : -1;
        }).map( c => (
            {
                ...c,
                magic_user: {
                    ...c.magic_user,
                    image: c.magic_user && c.magic_user.image ? c.magic_user.image : getUIAvatar(c.magic_user.email)
                }
            }
        ));
    }, [comments]);

    const CommentsNode = React.useMemo(()=>{
        const empty = (
            <Row className="row-centered-data">
                <Col xs={12} className={"center"}>
                    <h4>Este Articulo aun no tiene comentarios...</h4>
                </Col>
            </Row>
        );

        if (sortedComment === undefined) return empty;

        if (sortedComment.length === 0) return empty;

        return sortedComment.map(c => {
            return (
            <AnimateBox className="row animate-box comment-card" data-animate-effect="fadeInUp">
                <div className="col-xs-1">
                    <Image src={c.magic_user.image} roundedCircle/>
                </div>
                <div className="col-xs-11">
                    <h4 style={{borderBottom:'1px solid rgba(0,0,0,.25)', paddingBottom:10}}>
                        {c.magic_user.email}{' '}
                        (<small><Moment format={'LLL'} fromNow>{c.created}</Moment></small>)
                    </h4>
                    <p>{c.content}</p>
                </div>
            </AnimateBox>
            )
        });
    },[sortedComment])

    React.useEffect(()=>{
        if (blog){
            setTimeout(()=>{
                const bannerDescription = document.getElementById('banner-description');
                if(bannerDescription) bannerDescription.innerHTML = blog.title
            }, 300)
        }

        if ( blog !== undefined ){
            const element = 'fh5co-who-we-are';
            scrollTo(element);

            navigate(`/blog/${ id }/${slug}`);
        }

    }, [blog, id, navigate, scrollTo, slug]);

    React.useEffect(() => {
        const magicData = new Magic("pk_live_F4280DBBCF35A186", {
            network: {
                rpcUrl: "https://rpc-amoy.polygon.technology/",
                chainId: 80002
            },
            locale: 'es'
        });

        setMagic(magicData);
    }, [])

    React.useEffect( ()=>{
        const checkUser = async () => {
            if (!magic) return;

            try {
                // Verificamos si hay un usuario logueado
                const isLoggedIn = await magic.user.isLoggedIn();

                if (isLoggedIn) {
                    const token = await magic.user.getIdToken();
                    console.log("token", token);
                    setToken(token);

                    const userMetadata = await magic.user.getInfo();
                    console.log("userMetadata", userMetadata);
                    setUserInfo(userMetadata);
                }
            } catch (error) {
                console.error("Error al verificar la sesión:", error);
            }
        };

        checkUser().then();
    }, [magic] )

    React.useEffect(()=>{
        if (userInfo === null) return;

        setIsValidEmail(true);
        setEmail(userInfo.email || '');
    }, [userInfo])

    const logOut = React.useCallback(()=>{
        if (magic === undefined) return;
        magic.user.logout().then();
        setUserInfo(null);
        setToken(undefined);
        setEmail('');
        setIsValidEmail(true);
    }, [magic])

    const commentHandler = React.useCallback(()=>{
        if (token === undefined || id === undefined) return;

        addDetailBlogsCommentsAction.query({
            id: id,
            email: email,
            token: token,
            comment: commentSTR,
        }).then(r=>{
            if(r.payload){
                setIsLoadingComment(false)
                setCommentSTR('');
            }
        })

    }, [addDetailBlogsCommentsAction, email, id, token])

    const validateAccount = React.useCallback(async ()=>{
        if (magic === undefined) return;
        if (!validateEmail(email)) {
            setIsValidEmail(false);
            return;
        }



        magic.auth.loginWithEmailOTP({email: email, showUI: true})
            .then()
            .catch( err => {
                console.log(err);
            } );

        const newToken = await magic.user.getIdToken();
        setToken(newToken);

        const userMetadata = await magic.user.getInfo();
        setUserInfo(userMetadata);
    }, [email, magic])

    if (!isLoading || getDetailBlogsAction.loading ){
        return (
            <BlogSkeleton />
        );
    }

    if ( blog === undefined ){
        return (
            <React.Fragment>
                <div id="fh5co-who-we-are" className="fh5co-bg-section border-bottom">
                    <div className="container">
                        <div className="row row-pb-md">
                            <NotFound />
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }


    return (
        <React.Fragment>
            <div id="fh5co-who-we-are" className="fh5co-bg-section border-bottom">
                <div className="container">
                    <div className="row row-pb-md">
                        <AnimateBox className="col-md-8 col-md-offset-2 text-left animate-box">
                            <div className="fh5co-heading">
                                <span>AIEJA BLOG</span>
                                <h3>{ blog.title }</h3>
                            </div>
                        </AnimateBox>
                    </div>

                    <div className="row row-pb-md">
                        <AnimateBox className="col-xs-12 animate-box">
                            <div dangerouslySetInnerHTML={{__html: blog.body}} />
                        </AnimateBox>
                    </div>

                    <hr />

                    <Row className="border-bottom-title">
                        <Col xs={12} sm={8}>
                            <h3>Comentarios:</h3>
                        </Col>

                        <Col xs={12} sm={4} >
                            <Link
                                to={`/blog`}
                                className="btn btn-primary"
                                style={{ float: "right" }}
                                onClick={ _e => {
                                    window.scrollTo({ top: 0, behavior: 'smooth' });
                                } }
                            >
                                Ver Mas Artículos
                            </Link>
                        </Col>
                    </Row>


                    <Row>
                        { CommentsNode }
                    </Row>

                    { (userInfo === null && token === undefined ) ? (

                    <AnimateBox className="row animate-box row-pb-md" data-animate-effect="fadeInUp">
                        <div className="col-sm-12 text-left fh5co-heading" style={{marginTop: 20}}>
                            <form
                                action="#"
                                onSubmit={ (e) => {
                                    e.preventDefault();
                                    if( !isValidEmail ){
                                        return;
                                    }else{
                                        validateAccount();
                                    }
                                }}
                            >
                                <div className="row form-group">
                                    <div className="col-sm-12">
                                        <label htmlFor="fname">Email</label>
                                        <input type="email"
                                               id="email"
                                               className={`form-control ${!isValidEmail ? 'is-invalid' : ''}`}
                                               placeholder="Es necesario que valides tu cuenta para comentar"
                                               onChange={(e) => {
                                                   const value = e.target.value;
                                                   setEmail(value);
                                                   setIsValidEmail(validateEmail(value));
                                               }}
                                               value={email}
                                        />
                                        {!isValidEmail && (
                                            <div className="invalid-feedback">
                                                Por favor, ingresa una dirección de correo electrónico válida
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </form>
                            <Button
                                variant="primary"
                                disabled={magic === undefined || email.length === 0 || !isValidEmail}
                                onClick={ validateAccount }
                            >
                                Validar Cuenta
                            </Button>
                        </div>
                    </AnimateBox>
                    ) : (
                    <AnimateBox className="row animate-box row-pb-md" data-animate-effect="fadeInUp">
                        <div className="col-sm-12 text-left fh5co-heading" style={{marginTop: 20}}>
                            <form action="#">
                                <div className="row form-group">
                                    <div className="col-sm-12">
                                        <label htmlFor="fname">Hola {email} ¿Quieres comentar?...</label>
                                        <textarea
                                               id="fname"
                                               className="form-control"
                                               placeholder="Escribe un comentario para este articulo..."
                                               onChange={ (e) => setCommentSTR(e.target.value) }
                                               value={commentSTR}
                                               rows={5}
                                               disabled={getDetailBlogsCommentsAction.loading  || addDetailBlogsCommentsAction.loading}
                                        />
                                    </div>
                                </div>
                            </form>
                            <Button
                                variant="secondary"
                                onClick={logOut}
                            >
                                Cerrar Sesión
                            </Button>{'  '}
                            <Button
                                variant="primary"
                                disabled={commentSTR.length === 0 || getDetailBlogsCommentsAction.loading || addDetailBlogsCommentsAction.loading}
                                onClick={ commentHandler }
                            >
                                Comentar
                            </Button>
                        </div>
                    </AnimateBox>
                    )}
                </div>
            </div>
        </React.Fragment>
    )
}